import Loadable from '../../../../components/loadable';

export default Loadable(() =>
  import(/* webpackChunkName: "settings-update-account" */ './index')
);
